// 共通モバイル shell: header + main + (optional bottom nav)
// 各 prototype は MobileShell でラップして使う。
import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface Props {
  title: string;
  prototypeId: string;     // "A", "B", "C", "D", "E"
  prototypeName: string;   // "役員速報" 等
  asOfMonth?: string;
  children: ReactNode;
  bottomNav?: ReactNode;   // 案 B などで使う固定下部
  noPadding?: boolean;     // 案 D / E で main 内に余白を持ちたいとき false
  headerRight?: ReactNode; // header 右側 (asOfMonth pill の右) に追加 button 等
  // 月送り ←→ ボタン (sticky header に表示、 sidebar/drawer を開かずに月遷移可能) — 2026-05-26 追加
  onPrevMonth?: () => void;
  onNextMonth?: () => void;
  canPrevMonth?: boolean;  // 範囲外 (dateMin 到達) なら false で disabled
  canNextMonth?: boolean;
}

export function MobileShell({
  title, prototypeId, prototypeName, asOfMonth, children, bottomNav, noPadding, headerRight,
  onPrevMonth, onNextMonth, canPrevMonth = true, canNextMonth = true,
}: Props) {
  const monthNavBtn = "px-1.5 py-1 text-slate-600 text-xs leading-none rounded bg-slate-100 active:bg-slate-200 disabled:opacity-30 disabled:cursor-not-allowed";
  const hasMonthNav = onPrevMonth || onNextMonth;
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <header className="bg-white border-b border-slate-200 px-3 py-2 sticky top-0 z-30 flex items-center gap-2">
        <Link to="/m" className="text-slate-400 text-sm hover:text-slate-700" title="prototype 一覧へ">‹</Link>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] text-slate-400 leading-none">
            {prototypeId === "A" ? "📱" : `案 ${prototypeId}`} · {prototypeName}
          </div>
          <h1 className="text-sm font-semibold text-slate-800 truncate leading-tight">{title}</h1>
        </div>
        {asOfMonth && (
          <div className="flex items-center gap-0.5">
            {hasMonthNav && (
              <button type="button" className={monthNavBtn} disabled={!canPrevMonth}
                      onClick={onPrevMonth} title="前月" aria-label="前月">←</button>
            )}
            <div className="text-[10px] text-slate-500 px-2 py-1 bg-slate-100 rounded tabular-nums">
              {asOfMonth.slice(0, 7)}
            </div>
            {hasMonthNav && (
              <button type="button" className={monthNavBtn} disabled={!canNextMonth}
                      onClick={onNextMonth} title="翌月" aria-label="翌月">→</button>
            )}
          </div>
        )}
        {headerRight}
      </header>
      <main className={noPadding ? "flex-1 min-h-0" : "flex-1 min-h-0 px-3 py-3 space-y-3"}>
        {children}
      </main>
      {bottomNav && (
        <nav className="sticky bottom-0 bg-white border-t border-slate-200 px-2 py-2 z-20">
          {bottomNav}
        </nav>
      )}
      <footer className="text-[10px] text-slate-400 text-center py-3 bg-slate-50">
        モバイル版 ・ {prototypeName}
      </footer>
    </div>
  );
}
